/* eslint-disable */
/* Code generated by generator.ts DO NOT EDIT. */
// Generated: 04-11-2026 08:35:03

export enum EinduitstroomVSOStatus {
    INFORMATIE_VOLLEDIG = "Informatie volledig",
    GEEN_BEHAALD_UITSTROOMNIVEAU_GEREGISTREERD_BIJ_UITSCHRIJVING = "Geen behaald uitstroomniveau geregistreerd bij uitschrijving",
    ONGELDIG_BEHAALD_UITSTROOMNIVEAU_GEREGISTREERD_BIJ_UITSCHRIJVING = "Ongeldig behaald uitstroomniveau geregistreerd bij uitschrijving",
    NIET_UITGESCHREVEN = "Niet uitgeschreven",
    GEEN_EINDUITSTROOM = "Geen einduitstroom"
}
